import { render, staticRenderFns } from "./FeeStructures.vue?vue&type=template&id=33debcda"
import script from "./FeeStructures.vue?vue&type=script&lang=js"
export * from "./FeeStructures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports